import React from 'react'
import PropTypes from 'prop-types'
import FilterInput from './FilterInput'
import FilterSelect from './FilterSelect'


const ColumnFilter = (props) => {
    return (
        <div>
            <FilterInput {...props}/>
            <FilterSelect {...props}/>
        </div>
    )
}

ColumnFilter.propTypes = {
    changeFilter: PropTypes.func.isRequired,
    filter: PropTypes.object.isRequired,
    columnName: PropTypes.string.isRequired,
    filterSetting: PropTypes.object,
}

export default ColumnFilter




// WEBPACK FOOTER //
// ./src/modules/table/component/ColumnFilter.js